// AUTO-GENERATED by scripts/write-build-info.js — DO NOT EDIT.
// Regenerated at every `yarn start` and `yarn build`.
export const BUILD_COMMIT = "unknown";
export const BUILD_COMMITTED_AT = "2026-09-09T14:51:33.442Z";
export const BUILD_GENERATED_AT = "2026-09-09T14:51:33.442Z";
